var ActionSet =
/** @class */
function () {
  function ActionSet(context) {
    this.context = context;
    this.started = false;
    this.actions = new Set();
  }

  ActionSet.prototype.start = function () {
    if (!this.started) {
      this.started = true;
      this.connectActions();
    }
  };

  ActionSet.prototype.stop = function () {
    if (this.started) {
      this.disconnectActions();
      this.started = false;
    }
  };

  ActionSet.prototype.add = function (action) {
    if (!this.actions.has(action)) {
      action.connect();
      this.actions.add(action);
    }
  };

  ActionSet.prototype.delete = function (action) {
    if (this.actions.has(action)) {
      this.actions.delete(action);
      action.disconnect();
    }
  };

  ActionSet.prototype.connectActions = function () {
    this.actions.forEach(function (action) {
      return action.connect();
    });
  };

  ActionSet.prototype.disconnectActions = function () {
    this.actions.forEach(function (action) {
      return action.disconnect();
    });
  };

  return ActionSet;
}();

export { ActionSet };